import { Reveal, MaskedLines } from "../../components/Reveal";
import SectionNav from "../../components/SectionNav";
import { PageHero, CtaBand } from "../../components/ui";

const PILLARS = [
    {
        n: "01",
        t: "We understand the energy system",
        b: "Every project starts from what the power system actually needs — duration, grid need and market requirements — not from a technology looking for a home.",
    },
    {
        n: "02",
        t: "We develop complex infrastructure",
        b: "Large-scale storage is delivered through disciplined development: origination, consenting, grid connection, de-risking and financing.",
    },
    {
        n: "03",
        t: "We build a long-term platform",
        b: "AddiGen is building toward ownership and operation of storage assets that play a critical role in Europe's power system.",
    },
];

const MISSION_SECTIONS = [
    { id: "mission", label: "Mission" },
    { id: "pillars", label: "What drives it" },
];

export default function Mission() {
    return (
        <>
            <PageHero
                eyebrow="Company — Our Mission"
                lines={["Develop the storage", "Europe's power system needs."]}
                trail={[{ label: "Home", path: "/" }, { label: "Company" }, { label: "Our Mission" }]}
            />
            <SectionNav items={MISSION_SECTIONS} navKey="mission" />
            <section id="mission" className="bg-paper">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <Reveal>
                        <MaskedLines
                            animate={false}
                            lines={["Developing large-scale CAES and BESS projects", "to support Europe's decarbonisation and", "renewable energy targets."]}
                            className="max-w-5xl font-display text-2xl font-semibold leading-[1.35] tracking-[-0.01em] text-ink sm:text-3xl lg:text-4xl"
                        />
                    </Reveal>
                </div>
            </section>
            <section id="pillars" className="border-t border-line bg-white">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <div className="grid gap-12 lg:grid-cols-3">
                        {PILLARS.map((p, i) => (
                            <Reveal key={p.n} delay={i * 0.1}>
                                <div className="flex h-full flex-col border-t-2 border-ink pt-6">
                                    <span className="font-mono text-[11px] tracking-[0.2em] text-blue">{p.n}</span>
                                    <h3 className="h3-compact mt-5">{p.t}</h3>
                                    <p className="body-sm mt-4">{p.b}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
            <CtaBand cta="Talk to AddiGen" />
        </>
    );
}
